import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Header from '../../components/Header';
import TitleContent from '../../components/TitleContent';
import ProcedureGto from '../../components/ProcedureGto';
import CardGto from '../../components/GuidesListing/cardGto';
import { ContainedLoader } from '../../components/Loader';
import { ToastContainer, toast } from 'react-toastify';
import Wrapper from './wrapper';
import './index.scss';

import { allNotifications } from '../../utils/toastify';
const { notifyErrorBottomRight } = allNotifications;

class GtoDetailsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      gtoDetails: {},
      loadingGtoDetails: true
    };
  }

  notify = message => notifyErrorBottomRight(message, { position: toast.POSITION.BOTTOM_RIGHT });

  detailsGto_ME = () => {
    this.setState({ loadingGtoDetails: true });

    const gtoDetails = {
      beneficiary: {
        codBenef: 123,
        contrato: 123,
        nomeBenef: 'João da Silva',
        flagElegivel: true,
        dataVenc: '01/01/2020',
        dataAtualizacao: null
      },
      gtoId: 11301130,
      idOdonto: 25610,
      inclusionDate: '01/01/2020',
      updateDate: null,
      procedures: [
        {
          procedureId: 1234,
          planId: 35,
          gtoId: 11301130,
          idtProcGto: 4331123,
          isoProcedure: {
            codigo: 8410002,
            descricao: 'APLICAÇÃO TÓPICA DE FLÚOR',
            flagFaceObrig: false,
            flagDenteObrig: false,
            flagRegiaoObrig: true,
            flagImagemObrig: false,
            flagImgProcedimento: false,
            facesPermit: [],
            dentesPermit: [],
            listaRegiao: [],
            flagDentePerm: false,
            flagDenteDec: false,
            flgDivulga: true,
            qtdeFaces: 1,
            qtdeMaxFaces: 1
          },
          status: 'GLOSADO',
          face: '',
          region: 'ASAI',
          tooth: '',
          executeDate: '01/01/2020',
          images: [],
          justify: 'Justify',
          reason: '3081 - RADIOGRAFIA INICIAL NÃO ENVIADA',
          warning: 'warning',
          flagImgProcedimento: false,
          row: 1,
          dataPagamento: '01/01/2020',
          excluido: false,
          flagNecessitaLaudo: false,
          flagRxInicial: false,
          flagRxfinal: false
        },
        {
          procedureId: 1235,
          planId: 35,
          gtoId: 11301130,
          idtProcGto: 4331124,
          isoProcedure: {
            codigo: 85200018,
            descricao: 'CLAREAMENTO DE DENTE DESVITALIZADO',
            flagFaceObrig: false,
            flagDenteObrig: false,
            flagRegiaoObrig: true,
            flagImagemObrig: false,
            flagImgProcedimento: false,
            facesPermit: [],
            dentesPermit: [],
            listaRegiao: [],
            flagDentePerm: false,
            flagDenteDec: false,
            flgDivulga: true,
            qtdeFaces: 1,
            qtdeMaxFaces: 1
          },
          status: 'GLOSADO',
          face: '',
          region: 'ASAI',
          tooth: '',
          executeDate: '01/01/2020',
          images: [],
          justify: 'Justify',
          reason: 'Reason',
          warning: 'warning',
          flagImgProcedimento: false,
          row: 1,
          dataPagamento: '01/01/2020',
          excluido: false,
          flagNecessitaLaudo: false,
          flagRxInicial: false,
          flagRxfinal: false
        }
      ],
      observation: 'Observação do procedimento',
      status: 'GLOSADA'
    };

    this.setState({ gtoDetails: { ...gtoDetails }, loadingGtoDetails: false });

    // services.gto_ME('getDetailsGto_ME', { codigoPrestador: idOdonto, gtoId })
    //   .then(res => {
    //     this.setState({ gtoDetails: { ...gtoDetails }, loadingGtoDetails: false })
    //   })
    //   .catch(err => {
    //     this.setState({ gtoDetails: {}, loadingGtoDetails: false })
    //     this.notify(err.notify)
    //   })
  };

  componentWillMount = () => {
    this.detailsGto_ME();
  };

  render() {
    const { updateStatusProcedimento, gtosListError, /*procedures,*/ glosaCount } = this.props;

    const gtoDetails = this.state.gtoDetails;
    const {
      beneficiary,
      gtoId,
      inclusionDate,
      procedures
    } = gtoDetails;

    return (
      <Fragment>
        <Header class="title-center orange-gradient" name="Guias de Tratamento" />
        <div style={{ maxWidth: 415, margin: '0 auto', marginTop: 45 }}>
          {this.state.loadingGtoDetails ? (
            <ContainedLoader />
          ) : (
              <Fragment>
                <div className="GtoDetailsContainer">
                  <ul className="list">
                    <CardGto
                      state={this.props}
                      beneficiary={beneficiary}
                      inclusionDate={inclusionDate}
                    />
                  </ul>
                </div>

                <div className="summarizesProcedures">
                  <TitleContent color="blue" text="Procedimentos" />

                  <ul className="ProcedureGto">
                    {procedures &&
                      procedures.map((item, index) => (
                        <ProcedureGto
                          index={index}
                          key={index}
                          face={item.face}
                          status={item.status}
                          regiao={item.tooth}
                          glosaCount={glosaCount}
                          codBenef={beneficiary.nomeBenef}
                          readOnly={item.readOnly || false}
                          codCreden={item.codCreden}
                          codProced={item.isoProcedure.codigo}
                          descrGlosa={item.descrGlosa}
                          procedimento={item.isoProcedure.descricao}
                          reason={item.reason}
                          planId={item.planId}
                          gtoId={gtoId}
                          warning={item.warning}
                          procedureId={item.procedureId}
                          updateStatusProcedimento={updateStatusProcedimento}
                        />
                      ))}
                  </ul>
                </div>
                {gtosListError && <ToastContainer />}
              </Fragment>
            )}
        </div>
      </Fragment>
    );
  }
}

GtoDetailsContainer.propTypes = {
  procedures: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateStatusProcedimento: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  gtosListError: PropTypes.bool.isRequired,
  glosaCount: PropTypes.number.isRequired
};

const mapStateToProps = store => ({
  codigoPrestador: store.login.user.codigo
});

export default connect(mapStateToProps, {})(Wrapper(GtoDetailsContainer));
